import React from "react";

interface INullStateMessage{
  svgComponent?: JSX.Element;
  imageSrc?: string;
  message: string | JSX.Element;
  subMessage?: string | JSX.Element;
  messageClass?: string
  SubMessageClass?: string;
  imageHeight?: string;

}

const NullStateMessage = ({
  message, subMessage, messageClass, SubMessageClass, svgComponent, imageSrc, imageHeight = "10rem",
}:INullStateMessage) => {
  return (
    <div className="w-full h-full items-center flex justify-center">
      <div className="w-full flex flex-col items-center">
        {svgComponent ?
          svgComponent:
          imageSrc ?
            <div className="mb-4">
              <img
                src={imageSrc}
                style={{ height: imageHeight }}
              />
            </div> :
            null}

        <div className="text-center my-1.5">
          <div className={`font-semibold ${messageClass}`}>{message}</div>
          <div className={`text-sm ${SubMessageClass}`}>{subMessage}</div>
        </div>
      </div>
    </div>
  );
};

export default NullStateMessage;
